import { render, staticRenderFns } from "./ActivitiesGroupsCreateEdit.vue?vue&type=template&id=09052569"
import script from "./ActivitiesGroupsCreateEdit.vue?vue&type=script&lang=js"
export * from "./ActivitiesGroupsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports